import React, { useState, useEffect } from "react";
import Footer from "./layouts/Footer";
import Navbar from "./layouts/Navbar";
import AutoNotification from "./layouts/AutoNotification";
import Section from "./layouts/Section";
import { WebLink, SiteWide, Images } from "./customComponents";
import { mainStyle, mainColor, header } from '../utility/styles';
import Modal from 'react-modal';
import { useSelector, useDispatch } from 'react-redux';
import { tradeActions } from '../redux/actions';
import { userSelect, allRemoteSettingsSelect, homeScreenStatSelect, allTradeSelect } from '../redux/selectors/index';
import Helper1, { notify, styles, money, customModalStyles } from '../utility/Helper1';
import { useSnackbar } from 'snackfy';
import Countdown from 'react-countdown';
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en.json'
import ReactTimeAgo from 'react-time-ago'
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

const tradeBTN = require('../images/trade_button_bg.jpg');

const settings = {
  dots: true,
  slidesToShow: 3,
  infinite: true,
  accessibility: true,
  autoplay: false,

  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
};

function Trade() {
  const navigate = useNavigate();
  const userData = useSelector(userSelect);
  const site_settings = useSelector(allRemoteSettingsSelect);
  const finance = useSelector(homeScreenStatSelect);
  const tradesData = useSelector(allTradeSelect);

  const [openModal, setOpenModal] = useState(false);
  const [tradeAmount, setTradeAmount] = useState('');
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [selectedPlan, setSelectedPlan] = useState(null);

  const [loading, setloading] = useState(false);
  const [loadingText, setLoadingText] = useState('');
  const [tradeResultResponse, setTradeResultResponse] = useState();
  const [error, setError] = useState('');

  const dispatch = useDispatch();

  // Get currencies from system settings
  const systemCurrencies = site_settings?.plans?.map(plan => ({
    ...plan.mother,
    code: plan.mother?.abbr || plan.mother?.abbrRo,
    symbol: plan.mother?.symbol || '',
    name: plan.mother?.name || '',
    id: plan.mother?.id
  })).filter(currency => currency.code) || [];

   const prepareTradeModal = (planObjectSelected) => {
     if (!selectedCurrency) {
       notify('Please select a currency first', 0);
       return;
     }
     setSelectedPlan({ ...planObjectSelected });
     setError(''); // Clear any previous errors
     setOpenModal(true);
   }

   const tradeNow = () => {
    if (Number(finance?.[0]?.balance) < Number(finance?.[0]?.minimumParticipation)) {
      return;
    }

    if (isNaN(tradeAmount) || (tradeAmount <= 0)) {
      return;
    }

    if (!selectedCurrency) {
      notify('Please select a currency first', 0);
      return;
    }

     setloading(true);
     setLoadingText('Searching for appropriate trade entry...');
     setError(''); // Clear any previous errors when starting new trade

     dispatch(tradeActions.onPOSTTheTrades({ amount: tradeAmount, plan: selectedPlan?.type, currency: selectedCurrency.type }, "trade/new", response => {
       setloading(false)
       notify(response.msg, response.code);
       if (response.code == 1) {
         setloading(false);
         setOpenModal(false)
         navigate('/transactions')
       } else {
         setError(response.msg || 'An error occurred while processing your trade');
       }
     }),
     )
  }

   const resetSelection = () => {
     setSelectedPlan(null);
     setTradeAmount('');
     setError(''); // Clear error when resetting
     setOpenModal(false);
   }
  console.log('seleselectedCurrency.typectedCurrency', selectedCurrency)
  return (
    <SiteWide id="main" title={"Select a trade plan"}>
      <Section hideHeader={true} overlayText={loadingText} loading={loading} title={'Trade plan'}>

        <div className="min-h-screen to-slate-800">

          {/* Header */}
          <div className="container mx-auto px-4 pt-12 pb-8">
            <div className="text-center max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
                {site_settings?.content_settings?.[0]?.con7 || 'Trading Plans'}
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed">
                {site_settings?.content_settings?.[0]?.con8 || 'Select your preferred currency and trading plan'}
              </p>
            </div>
          </div>

          {/* Currency Selection - Must be first */}
          <div className="container mx-auto px-4 mb-12">
            <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8">
              <h2 className="text-2xl font-semibold text-white mb-6 text-center">
                Select Trading Currency
              </h2>
              <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
                {systemCurrencies.map((currency) => (
                  <button
                    key={currency.code}
                    onClick={() => setSelectedCurrency(currency)}
                    className={`p-4 rounded-xl border-2 transition-all duration-300 ${selectedCurrency.code == currency.code
                      ? 'border-cyan-400 bg-cyan-400/10 text-cyan-400'
                      : 'border-slate-600 bg-slate-800/50 text-gray-300 hover:border-slate-500'
                      }`}
                  >
                    <div className="text-2xl mb-1">{currency.symbol}</div>
                    <div className="font-semibold">{currency.code}</div>
                    <div className="text-xs text-gray-400">{currency.name}</div>
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Trading Plans */}
          {selectedCurrency && (
            <div className="container mx-auto px-4 mb-12">

              <div className="w-full">
                {site_settings?.plans?.map((planGroup, planIndex) => {
                  // Filter plans by selected currency
                  if (planGroup.mother?.abbr !== selectedCurrency.code && planGroup.mother?.abbrRo !== selectedCurrency.code) {
                    return null;
                  }

                  return planGroup.childs?.map((item, index) => {
                    let totalFreq = 24 / item.hoursProfitComesBack;
                    const isSelected = selectedPlan?.name === item.name;

                    return (
                      <div
                        key={`${planIndex}-${index}`}
                        className={`relative bg-slate-800/50 backdrop-blur-sm border-2 rounded-2xl p-6 transition-all duration-300 cursor-pointer w-full mb-6 ${isSelected
                          ? 'border-cyan-400 shadow-lg shadow-cyan-400/20'
                          : 'border-slate-700 hover:border-slate-600'
                          }`}
                        onClick={() => prepareTradeModal(item)}
                      >
                        {/* Plan Header */}
                        <div className="text-center mb-6">
                          {/* <div className="inline-block px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-sm font-semibold rounded-full mb-4">
                            {item.name}
                          </div> */}
                          <div className="text-3xl font-bold text-white mb-2">
                            {(Number(item?.roi?.split(",").reduce((acc, num) => acc + parseFloat(num), 0)).toFixed(1))}%
                          </div>
                          <div className="text-gray-400">Total Returns</div>
                        </div>

                        {/* Plan Features */}
                        <div className="space-y-3 mb-6">
                          <div className="flex items-center justify-between text-gray-300">
                            <span>Min Trade:</span>
                            <span className="font-semibold">{money(item.minimumParticipation, selectedCurrency?.type)}</span>
                          </div>
                          <div className="flex items-center justify-between text-gray-300">
                            <span>Max Trade:</span>
                            <span className="font-semibold">{money(item.maximumParticipation, selectedCurrency?.type)}</span>
                          </div>
                          <div className="flex items-center justify-between text-gray-300">
                            <span>Daily Rounds:</span>
                            <span className="font-semibold">{item?.roi?.split(",")?.[0]}%</span>
                          </div>
                        </div>


                        {/* Select Plan Button */}
                        <div className="flex justify-center mb-4">
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              prepareTradeModal(item);
                            }}
                            className="bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300 transform hover:scale-105"
                          >
                            Continue
                          </button>
                        </div>

                        {isSelected && (
                          <div className="absolute top-4 right-4">
                            <div className="w-3 h-3 bg-cyan-400 rounded-full"></div>
                          </div>
                        )}
                      </div>
                    );
                  });
                }).filter(Boolean)}
              </div>
            </div>
          )}

          {/* Trade Amount Modal */}
          <Modal
            isOpen={openModal}
            onRequestClose={() => setOpenModal(false)}
            style={customModalStyles}
            contentLabel="Trade Amount Modal"
          >
            {selectedPlan && (
              <div className="bg-slate-800 rounded-2xl p-8 max-w-2xl mx-auto">
                <h2 className="text-2xl font-semibold text-white mb-6 text-center">
                  Enter Trade Amount
                </h2>

                {/* Selected Plan Summary */}
                <div className="bg-slate-700/50 rounded-xl p-4 mb-6">
                  <div className="flex justify-between items-center text-white">
                    <span className="font-semibold">Balance: </span>
                    <span className="text-cyan-400 font-bold">
                      {money(finance?.filter(el => el.type == selectedCurrency.type)?.[0]?.balance || 0, selectedCurrency?.type)}
                    </span>
                  </div>
                  <div className="text-gray-400 text-sm mt-1">
                    Range: {money(selectedPlan.minimumParticipation, selectedCurrency.type)} - {money(selectedPlan.maximumParticipation, selectedCurrency)}
                  </div>
                </div>

                {/* Amount Input */}
                <div className="mb-6">
                  <label className="block text-white text-sm font-semibold mb-2">
                    Trade Amount ({selectedCurrency.code})
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      value={tradeAmount}
                      onChange={(e) => setTradeAmount(e.target.value)}
                      placeholder="0.00"
                      className="w-full bg-slate-700 border border-slate-600 text-white text-xl px-4 py-4 rounded-xl focus:border-cyan-400 focus:outline-none transition-colors"
                    />
                    <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                      {systemCurrencies.find(c => c.code === selectedCurrency.code)?.symbol}
                    </div>
                  </div>
                </div>

                 {/* Validation Messages */}
                 {tradeAmount && (
                   <div className="mb-6">
                     {(Number(finance?.[0]?.balance) < Number(tradeAmount)) && (
                       <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg mb-3">
                         Account balance insufficient for this trade amount
                       </div>
                     )}
                     {(Number(tradeAmount) < Number(selectedPlan?.minimumParticipation)) && (
                       <div className="bg-yellow-500/10 border border-yellow-500/20 text-yellow-400 px-4 py-3 rounded-lg mb-3">
                         Amount below minimum trade limit
                       </div>
                     )}
                     {(Number(tradeAmount) > Number(selectedPlan?.maximumParticipation)) && (
                       <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg mb-3">
                         Amount exceeds maximum trade limit
                       </div>
                     )}
                   </div>
                 )}

                 {/* Error Message */}
                 {error && (
                   <div className="mb-6">
                     <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-3 rounded-lg">
                       {error}
                     </div>
                   </div>
                 )}

                {/* Action Buttons */}
                <div className="flex gap-4">
                  <button
                    onClick={resetSelection}
                    className="flex-1 bg-slate-700 hover:bg-slate-600 text-white py-4 px-6 rounded-xl font-semibold transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={tradeNow}
                    disabled={!tradeAmount || loading ||
                      Number(tradeAmount) < Number(selectedPlan?.minimumParticipation) ||
                      Number(tradeAmount) > Number(selectedPlan?.maximumParticipation) ||
                      Number(finance?.[0]?.balance) < Number(tradeAmount)}
                    className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white py-4 px-6 rounded-xl font-semibold transition-all duration-300"
                  >
                    {loading ? 'Processing...' : 'Submit'}
                  </button>
                </div>
              </div>
            )}
          </Modal>
        </div>
      </Section>
    </SiteWide>
  );
}

export default Trade;